import { render, staticRenderFns } from "./prescriptionOrderList.vue?vue&type=template&id=2374ab52&scoped=true"
import script from "./prescriptionOrderList.vue?vue&type=script&lang=js"
export * from "./prescriptionOrderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2374ab52",
  null
  
)

export default component.exports